import { render } from "./2WWF.vue?vue&type=template&id=18d670d0"
import script from "./2WWF.vue?vue&type=script&lang=js"
export * from "./2WWF.vue?vue&type=script&lang=js"
script.render = render

export default script